import type { Route } from 'vue-router'
import type { Store } from 'vuex'

import type { GuardResolveFunction } from '../models'
import { CONTAINER } from '../config'

import { TYPES } from '../config/inversify.types'
import { GuardClass } from '../models'

import { ROUTER_CONSTS } from '../router/router.consts'

import { APP_CONSTS } from '../store/app/app.consts'

export class SetFullscreenFromUrlGuard extends GuardClass {
  static async execute(
    this: void,
    to: Route,
    from: Route,
    next: GuardResolveFunction,
  ): Promise<void> {
    const store = CONTAINER.get<Store<any>>(TYPES.Store)
    const fullscreen = to.query[ROUTER_CONSTS.query.fullscreen] === 'true'
    await store.dispatch(`${APP_CONSTS.moduleName}/${APP_CONSTS.actions.setFullscreen}`, fullscreen)
    next()
  }
}
